var map = {
	"./about_en.md": "M8yz",
	"./contact_en.md": "UxNW",
	"./datenschutz_en.md": "UrWw",
	"./impressum_en.md": "o5hb",
	"./jobs_en.md": "JMSu",
	"./menu_en.md": "Jykc",
	"./news_en.md": "u5BH",
	"./opening_en.md": "XkuR",
	"./press_en.md": "YFuu",
	"./veg_en.md": "B1xd",
	"./wine_en.md": "nMCl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EcV9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy ^\.\/.*_en\.md$
// module id = EcV9
// module chunks = 0